import type { FeedbackCollectorConfig } from '@/types/feedbackCollector';

let cachedFeedbackCollectorConfig: FeedbackCollectorConfig | null = null;

const FALLBACK_ACCOUNT_TOKEN = '7cduedjgpuu42dw3y5bkdp50c2669761';

export const feedbackConfigService = {
  async getFeedbackCollectorConfig(): Promise<FeedbackCollectorConfig> {
    if (cachedFeedbackCollectorConfig) {
      return cachedFeedbackCollectorConfig;
    }

    const envToken = import.meta.env?.VITE_FEEDBACK_COLLECTOR_ACCOUNT_TOKEN;

    const defaultFeedbackCollectorConfig: FeedbackCollectorConfig = {
      apiHost: 'https://api.sentiment.accessacloud.com',
      accountToken: envToken || FALLBACK_ACCOUNT_TOKEN,
      product: 'Scheduler',
    };

    try {
      const response = await fetch('/config/feedbackCollector.config.json');
      if (!response.ok) {
        return defaultFeedbackCollectorConfig;
      }

      const configFromFile = await response.json();
      cachedFeedbackCollectorConfig = {
        ...defaultFeedbackCollectorConfig,
        ...configFromFile,
        accountToken: envToken || configFromFile.accountToken || FALLBACK_ACCOUNT_TOKEN,
      };
      return cachedFeedbackCollectorConfig!;
    } catch {
      return defaultFeedbackCollectorConfig;
    }
  },

  clearCache(): void {
    cachedFeedbackCollectorConfig = null;
  },
};
